"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useToggle = require("./useToggle");
Object.keys(_useToggle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useToggle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useToggle[key];
    }
  });
});